import { render } from "./LogoutIcon.vue?vue&type=template&id=c34b443e&ts=true"
import script from "./LogoutIcon.vue?vue&type=script&lang=ts"
export * from "./LogoutIcon.vue?vue&type=script&lang=ts"

import exportComponent from "/container/procurement-dev.jd.net.nz/application/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__